// Where the station finds the API and the sync service.
//
// A build can name them outright (`VITE_ENP_API_URL`, `VITE_ENP_SYNC_URL`: the native and
// Electron builds do). A value that is only a path (`/enp-api`) means "on the server this
// page came from": ENP3's `npm run dev` serves both under the station dev server's own
// origin, so the same dev build works at http://localhost:5174 on the PC and at
// https://<pc-ip>:5443 on a tablet, with no address baked into the bundle and no mixed
// content (B-078, B-079).

export interface PageLocation {
  protocol: string;
  hostname: string;
  origin: string;
}

/** A configured URL, with a path-only value resolved against the page's origin. */
export function resolveServiceUrl(configured: string, page: PageLocation): string {
  return configured.startsWith('/') && !configured.startsWith('//')
    ? `${page.origin}${configured}`
    : configured;
}

/**
 * The API: the configured URL, else (a browser on the LAN during development) the dev API on
 * the same host, port 4000 (CONVENTIONS §9).
 */
export function apiBaseUrlFor(configured: string | undefined, page: PageLocation): string {
  if (configured) return resolveServiceUrl(configured, page);
  return page.protocol === 'http:' || page.protocol === 'https:'
    ? `${page.protocol}//${page.hostname}:4000`
    : 'http://localhost:4000';
}

/** The sync service, or undefined when none is configured (commands upload; nothing downloads). */
export function syncUrlFor(configured: string | undefined, page: PageLocation): string | undefined {
  return configured ? resolveServiceUrl(configured, page) : undefined;
}
